module.exports = __webpack_public_path__ + "static/img/04_空気清浄機.de39d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04_空気清浄機.png
// module id = LuuT
// module chunks = 0